(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gs-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.gsCollectionSortReady) return;
    window.gsCollectionSortReady = true;

    /** @param {HTMLSelectElement} select */
    const syncLabel = (select) => {
      const value = select.closest('.gs-sort')?.querySelector('.gs-sort__value');
      const option = select.options[select.selectedIndex];
      if (value && option) value.textContent = option.text.trim();
    };

    document.addEventListener('change', (event) => {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement) || !select.matches('[data-gs-sort]')) return;

      const form = select.form;
      if (!form) return;

      syncLabel(select);
      select.closest('.gs-collection')?.classList.add('gs-collection--sorting');

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });

    // Restored from the back/forward cache: show the sort that matches the rendered grid again.
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;

      for (const select of document.querySelectorAll('select[data-gs-sort]')) {
        if (!(select instanceof HTMLSelectElement)) continue;
        const rendered = Array.from(select.options).find((option) => option.defaultSelected);
        if (rendered) select.value = rendered.value;
        syncLabel(select);
      }

      for (const section of document.querySelectorAll('.gs-collection--sorting')) {
        section.classList.remove('gs-collection--sorting');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-product-row"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gs-product-row')) {
    class GsProductRow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-gs-track]');
        this.prevButton = this.querySelector('[data-gs-prev]');
        this.nextButton = this.querySelector('[data-gs-next]');
        if (!this.track) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.prevButton?.addEventListener('click', () => this.go(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.go(1), { signal });
        this.track.addEventListener('scroll', () => this.queueUpdate(), { signal, passive: true });

        this.resizeObserver = new ResizeObserver(() => this.queueUpdate());
        this.resizeObserver.observe(this.track);

        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      queueUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const { track } = this;
        if (!track) return;
        const maxScroll = track.scrollWidth - track.clientWidth;
        const position = Math.abs(track.scrollLeft);
        const scrollable = maxScroll > 2;

        this.toggleAttribute('data-scrollable', scrollable);
        if (this.prevButton) this.prevButton.disabled = !scrollable || position <= 2;
        if (this.nextButton) this.nextButton.disabled = !scrollable || position >= maxScroll - 2;
      }

      go(direction) {
        const { track } = this;
        const item = track.querySelector('li');
        if (!item) return;

        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap) || 0;
        const step = item.getBoundingClientRect().width + gap;
        const visibleWidth =
          track.clientWidth - (parseFloat(styles.paddingInlineStart) || 0) - (parseFloat(styles.paddingInlineEnd) || 0);
        const perPage = Math.max(1, Math.floor((visibleWidth + gap + 1) / step));
        const rtl = styles.direction === 'rtl' ? -1 : 1;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        track.scrollBy({ left: direction * rtl * step * perPage, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    customElements.define('gs-product-row', GsProductRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
